import api from './api';

// Helper para extrair dados da resposta
const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const schedulesService = {
  // Listar todas as schedules (inclui excluídas para filtro client-side)
  getAll: async () => {
    const response = await api.get('/schedules?includeDeleted=true');
    const data = extractData(response.data);
    const schedules = data.schedules || [];
    console.log('[schedulesService] Total schedules (incluindo excluídas):', schedules.length);
    return schedules;
  },

  // Buscar todos os dados (schedules, professionals, places)
  getAllWithRelations: async () => {
    const response = await api.get('/schedules?includeDeleted=true');
    const data = extractData(response.data);
    const schedules = data.schedules || [];
    console.log('[schedulesService] getAllWithRelations - Total (incluindo excluídas):', schedules.length);
    return {
      schedules,
      professionals: data.professionals || [],
      places: data.places || []
    };
  },

  // Buscar schedule por ID
  getById: async (id) => {
    const response = await api.get(`/schedules/${id}`);
    return extractData(response.data);
  },

  // Criar nova schedule
  create: async (data) => {
    const response = await api.post('/schedules', data);
    return extractData(response.data);
  },

  // Atualizar schedule
  update: async (id, data) => {
    const response = await api.put(`/schedules/${id}`, data);
    return extractData(response.data);
  },

  // Deletar schedule
  delete: async (id) => {
    console.log('[schedulesService] delete chamado com ID:', id);
    console.log('[schedulesService] Fazendo DELETE request para:', `/schedules/${id}`);
    
    try {
      const response = await api.delete(`/schedules/${id}`);
      console.log('[schedulesService] DELETE response:', response);
      console.log('[schedulesService] response.data:', response.data);
      
      const result = extractData(response.data);
      console.log('[schedulesService] extractData result:', result);
      
      return result;
    } catch (error) {
      console.error('[schedulesService] ERRO em delete:', error);
      console.error('[schedulesService] Error response:', error.response);
      console.error('[schedulesService] Error stack:', error.stack);
      throw error;
    }
  },

  // Listar turnos de uma schedule
  getShifts: async (agendaId, includeDeleted = false) => {
    const params = includeDeleted ? '?includeDeleted=true' : '';
    const response = await api.get(`/schedules/${agendaId}/shifts${params}`);
    return extractData(response.data);
  },

  // Adicionar turno a uma schedule
  addShift: async (agendaId, shiftData) => {
    const response = await api.post(`/schedules/${agendaId}/shifts`, shiftData);
    return extractData(response.data);
  },

  // Atualizar turno
  updateShift: async (agendaId, shiftId, shiftData) => {
    const response = await api.put(`/schedules/${agendaId}/shifts/${shiftId}`, shiftData);
    return extractData(response.data);
  },

  // Remover turno
  deleteShift: async (agendaId, shiftId) => {
    const response = await api.delete(`/schedules/${agendaId}/shifts/${shiftId}`);
    return extractData(response.data);
  },

  // Buscar turno específico por ID
  getShiftById: async (agendaId, shiftId) => {
    const response = await api.get(`/schedules/${agendaId}/shifts/${shiftId}`);
    return extractData(response.data);
  },

  // Criar turno (alias para addShift - compatibilidade)
  createShift: async (agendaId, shiftData) => {
    return schedulesService.addShift(agendaId, shiftData);
  },

  // Toggle ativo/inativo de um turno
  toggleShiftActive: async (agendaId, shiftId) => {
    const response = await api.patch(`/schedules/${agendaId}/shifts/${shiftId}/toggle-active`);
    return extractData(response.data);
  },

  // Liga/desliga a AGENDA inteira. Pausar é a decisão mais consequente da tela: enquanto
  // pausada, nenhuma página consegue marcar horário nela.
  toggleActive: async (agendaId) => {
    const response = await api.patch(`/schedules/${agendaId}/toggle-active`);
    return extractData(response.data);
  },
};

export default schedulesService;
